var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.authenticated || _vm.$route.path === "/account/reset/request"
    ? _c(
        "v-app-bar",
        {
          key: _vm.key,
          class: {
            "d-flex justify-content-center": !_vm.authenticated,
            "nav-header": true,
          },
          attrs: {
            app: "",
            flat: "",
            id: "navbar",
            elevation: _vm.authenticated ? 4 : 0,
          },
        },
        [
          _vm.authenticated
            ? _c(
                "v-btn",
                {
                  staticClass: "d-lg-none",
                  attrs: {
                    "active-class":
                      "navbar-btn--active blue--text font-weight-bold",
                    icon: "",
                    plain: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleDrawer()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-menu")])],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-toolbar-title",
            {
              staticClass: "title d-flex mx-auto",
              on: {
                click: function ($event) {
                  return _vm.navigateTo("/")
                },
              },
            },
            [
              _c("img", {
                staticClass: "logo",
                attrs: { src: _vm.slmLogo, alt: "SLM" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.authenticated
            ? _c(
                "div",
                {
                  staticClass:
                    "navbar-btn-group d-none d-md-flex flex-row ml-4",
                },
                [
                  _vm._l(_vm.menu.items, function (item) {
                    return [
                      item.isVisible
                        ? _c(
                            "v-btn",
                            {
                              key: item.title,
                              attrs: {
                                to: item.route,
                                "active-class":
                                  "navbar-btn--active blue--text font-weight-bold",
                                link: "",
                                text: "",
                                tile: "",
                                plain: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n        " + _vm._s(item.title) + "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                  _vm._v(" "),
                  _vm._l(
                    _vm.menu.settings.filter((item) => item.isVisible),
                    function (item) {
                      return _c(
                        "v-menu",
                        {
                          key: item.title,
                          attrs: {
                            "close-on-click": "",
                            "offset-y": "",
                            bottom: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            class: {
                                              "navbar-btn--active blue--text font-weight-bold":
                                                _vm.subIsActive(
                                                  _vm.settingsRoutes
                                                ),
                                            },
                                            attrs: {
                                              link: "",
                                              text: "",
                                              tile: "",
                                              plain: "",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n          " +
                                            _vm._s(item.title) +
                                            "\n          "
                                        ),
                                        _c("v-icon", { staticClass: "pl-1" }, [
                                          _vm._v("mdi-chevron-down"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "", "no-action": "" } },
                            [
                              _vm._l(item.items, function (child) {
                                return [
                                  child.isVisible
                                    ? _c(
                                        "v-list-item",
                                        {
                                          key: child.title,
                                          attrs: {
                                            to: child.route,
                                            link: "",
                                            "active-class":
                                              "blue--text font-weight-bold",
                                          },
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(child.title)),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
                    ? _vm._l(_vm.menu.adminSettings, function (item) {
                        return _c(
                          "v-menu",
                          {
                            key: item.title,
                            attrs: {
                              "close-on-click": "",
                              "offset-y": "",
                              bottom: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              class: {
                                                "navbar-btn--active blue--text font-weight-bold":
                                                  _vm.subIsActive("/admin"),
                                              },
                                              attrs: {
                                                link: "",
                                                text: "",
                                                tile: "",
                                                plain: "",
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(item.title) +
                                              "\n            "
                                          ),
                                          _c(
                                            "v-icon",
                                            { staticClass: "pl-1" },
                                            [_vm._v("mdi-chevron-down")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              { attrs: { dense: "", "no-action": "" } },
                              _vm._l(item.items, function (child) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: child.title,
                                    attrs: {
                                      to: child.route,
                                      link: "",
                                      "active-class":
                                        "blue--text font-weight-bold",
                                    },
                                  },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(child.title)),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer", { staticClass: "d-none d-lg-block" }),
          _vm._v(" "),
          _vm.authenticated
            ? _c(
                "div",
                {
                  staticClass:
                    "search-wrapper w-25 d-none d-lg-flex position-relative",
                },
                [
                  _c("v-text-field", {
                    staticClass: "w-100",
                    attrs: {
                      id: "search",
                      type: "text",
                      placeholder: "Search for Order, Product, Product Type",
                      dense: "",
                      flat: "",
                      outlined: "",
                      "hide-details": "",
                    },
                    on: { input: _vm.openMenu },
                    scopedSlots: _vm._u(
                      [
                        _vm.searchText
                          ? {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        color: "#00000040",
                                      },
                                      on: { click: _vm.clearSearch },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-close-circle"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "p-2",
                      staticStyle: { "border-left": "1px solid #d9d9d9" },
                    },
                    [_c("v-icon", [_vm._v("mdi mdi-magnify")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "overlay-opacity": "0.2" },
                      model: {
                        value: _vm.mobileMenuOpen,
                        callback: function ($$v) {
                          _vm.mobileMenuOpen = $$v
                        },
                        expression: "mobileMenuOpen",
                      },
                    },
                    [
                      _c("div", { staticClass: "mobile-search w-auto" }, [
                        _c(
                          "div",
                          {
                            staticClass: "search-wrapper bg-white d-flex",
                            staticStyle: { width: "90vw" },
                          },
                          [
                            _c("v-text-field", {
                              staticClass: "w-100",
                              attrs: {
                                id: "search",
                                type: "text",
                                placeholder:
                                  "Search for Order, Product, Product Type",
                                dense: "",
                                flat: "",
                                outlined: "",
                                "hide-details": "",
                                autofocus: "",
                              },
                              on: { input: _vm.openMenu },
                              scopedSlots: _vm._u(
                                [
                                  _vm.searchText
                                    ? {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: "#00000040",
                                                },
                                                on: { click: _vm.clearSearch },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-close-circle")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.searchText,
                                callback: function ($$v) {
                                  _vm.searchText = $$v
                                },
                                expression: "searchText",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "p-2",
                                staticStyle: {
                                  "border-left": "1px solid #d9d9d9",
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi mdi-magnify")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "position-x": _vm.positionX,
                        "position-y": _vm.positionY,
                        "nudge-bottom": _vm.isMobile ? 125 : 55,
                        "max-width": _vm.isMobile ? "94%" : "80%",
                        "min-width": _vm.isMobile ? "94%" : _vm.width,
                        absolute: "",
                        "offset-y": "",
                      },
                      model: {
                        value: _vm.menuOpen,
                        callback: function ($$v) {
                          _vm.menuOpen = $$v
                        },
                        expression: "menuOpen",
                      },
                    },
                    [
                      _c(
                        "v-list",
                        {
                          attrs: {
                            id: "search-list",
                            subheader: "",
                            dense: "",
                          },
                        },
                        [
                          _c(
                            "v-subheader",
                            {
                              staticClass:
                                "d-flex justify-space-between font-weight-bold px-4",
                            },
                            [
                              _c("span", { staticStyle: { color: "#000" } }, [
                                _vm._v("ORDER"),
                              ]),
                              _vm._v(" "),
                              _vm.searchResults.orders.totalCount > 0
                                ? _c(
                                    "b-link",
                                    {
                                      attrs: {
                                        color: "primary",
                                        to: `/order?searchParam=${_vm.searchText}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            `See all ${_vm.searchResults.orders.totalCount} results`
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-group",
                            [
                              _vm._l(
                                _vm.searchResults.orders.items?.slice(0, 3),
                                function (order) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: "orders-" + order.id,
                                      attrs: {
                                        dense: "",
                                        link: "",
                                        to: `/order/${order.id}/view`,
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.displayResult(order, "orders")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.searchResults.orders.totalCount === 0
                                ? _c(
                                    "v-list-item",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { color: "#00000040" },
                                        },
                                        [_vm._v("No orders found")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-subheader",
                            {
                              staticClass:
                                "d-flex justify-space-between font-weight-bold px-4",
                            },
                            [
                              _c("span", { staticStyle: { color: "#000" } }, [
                                _vm._v("PRODUCT"),
                              ]),
                              _vm._v(" "),
                              _vm.searchResults.products.totalCount > 0
                                ? _c(
                                    "b-link",
                                    {
                                      attrs: {
                                        color: "primary",
                                        to: `/product?searchParam=${_vm.searchText}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            `See all ${_vm.searchResults.products.totalCount} results`
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-group",
                            [
                              _vm._l(
                                _vm.searchResults.products.items?.slice(0, 3),
                                function (product) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: "product-" + product.id,
                                      attrs: {
                                        dense: "",
                                        link: "",
                                        to: `/product?searchId=${product.id}`,
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.displayResult(
                                              product,
                                              "products"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.searchResults.products.totalCount === 0
                                ? _c(
                                    "v-list-item",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { color: "#00000040" },
                                        },
                                        [_vm._v("No products found")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-subheader",
                            {
                              staticClass:
                                "d-flex justify-space-between font-weight-bold px-4",
                            },
                            [
                              _c("span", { staticStyle: { color: "#000" } }, [
                                _vm._v("PRODUCT TYPE"),
                              ]),
                              _vm._v(" "),
                              _vm.searchResults.productTypes.totalCount > 0
                                ? _c(
                                    "b-link",
                                    {
                                      attrs: {
                                        color: "primary",
                                        to: `/product-type?searchParam=${_vm.searchText}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            `See all ${_vm.searchResults.productTypes.totalCount} results`
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-group",
                            [
                              _vm._l(
                                _vm.searchResults.productTypes.items?.slice(
                                  0,
                                  3
                                ),
                                function (productType) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: "product-type-" + productType.id,
                                      attrs: {
                                        dense: "",
                                        link: "",
                                        to: `/product-type?searchId=${productType.id}`,
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.displayResult(
                                              productType,
                                              "productType"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.searchResults.productTypes.totalCount === 0
                                ? _c(
                                    "v-list-item",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { color: "#00000040" },
                                        },
                                        [_vm._v("No product types found")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated && _vm.lgAndUp
            ? _c(
                "div",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "", left: "", "nudge-bottom": "10" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "position-relative" },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            id: "user-notification-btn",
                                            icon: "",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi mdi-bell-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.notificationCount(
                                      _vm.headerNotifications
                                    )
                                      ? _c(
                                          "v-chip",
                                          { staticClass: "notification-chip" },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.notificationCount(
                                                    _vm.headerNotifications
                                                  )
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2786514653
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          attrs: {
                            id: "user-notification-list",
                            "min-width": "226",
                          },
                        },
                        [
                          _vm._l(
                            _vm.headerNotifications.slice(0, 4),
                            function (notif, index) {
                              return _c(
                                "v-list-item",
                                {
                                  key: notif.id,
                                  class: [
                                    notif.viewed ? "viewed" : "",
                                    "notification-item",
                                  ],
                                  attrs: {
                                    id: "user-notification-item-" + index,
                                    link: "",
                                    to: {
                                      name: "OrderView",
                                      params: { orderId: notif.orderId },
                                    },
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.patchNotification(notif.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "home.widgets.headerNotification.message",
                                                  {
                                                    status: _vm.transformText(
                                                      notif.status
                                                    ),
                                                  }
                                                )
                                              ) +
                                              ".\n              "
                                          ),
                                          _c("div", [
                                            _vm._v("\n                ("),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text-decoration-underline cursor--pointer",
                                                staticStyle: {
                                                  width: "fit-content",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    `OR#${notif.orderNumber}`
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(")\n              "),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          !_vm.headerNotifications.length
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _c(
                                          "h1",
                                          {
                                            staticClass:
                                              "subtitle-2 font-weight-bold text-center mb-0",
                                            staticStyle: { color: "#c7cacc" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "home.widgets.headerNotification.notFound"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                id: "view-all-notification",
                                                text: "",
                                                link: "",
                                                color: "primary",
                                                to: { name: "Notifications" },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "home.widgets.headerNotification.viewAll"
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "View all notifications"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authenticated
            ? _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "px-3 d-flex d-lg-none",
                      on: {
                        click: function ($event) {
                          _vm.mobileMenuOpen = true
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.mobileMenuOpen ? "primary" : "inherit",
                          },
                        },
                        [_vm._v("mdi mdi-magnify")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.hasAnyAuthority("ROLE_ADMIN") &&
                  _vm.authenticated &&
                  !_vm.lgAndUp
                    ? _c(
                        "div",
                        { staticClass: "pr-3 d-flex align-center" },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                left: "",
                                "nudge-bottom": "10",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "position-relative" },
                                          [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    id: "user-notification-btn",
                                                    icon: "",
                                                    small: "",
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v(
                                                    "mdi mdi-bell-outline"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.notificationCount(
                                              _vm.headerNotifications
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "notification-chip",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              " +
                                                        _vm._s(
                                                          _vm.notificationCount(
                                                            _vm.headerNotifications
                                                          )
                                                        ) +
                                                        "\n            "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2200397332
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  attrs: {
                                    id: "user-notification-list",
                                    "min-width": "226",
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.headerNotifications.slice(0, 4),
                                    function (notif) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: notif.id,
                                          class: [
                                            notif.viewed ? "viewed" : "",
                                            "notification-item",
                                          ],
                                          attrs: {
                                            id:
                                              "user-notification-item-" +
                                              _vm.index,
                                            link: "",
                                            to: {
                                              name: "OrderView",
                                              params: {
                                                orderId: notif.orderId,
                                              },
                                            },
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.patchNotification(
                                                notif.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "home.widgets.headerNotification.message",
                                                          {
                                                            status:
                                                              _vm.transformText(
                                                                notif.status
                                                              ),
                                                          }
                                                        )
                                                      ) +
                                                      ".\n                "
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                  ("
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "blue--text text-decoration-underline cursor--pointer",
                                                        staticStyle: {
                                                          width: "fit-content",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            `OR#${notif.orderNumber}`
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      ")\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  !_vm.headerNotifications.length
                                    ? _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "subtitle-2 font-weight-bold text-center mb-0",
                                                    staticStyle: {
                                                      color: "#c7cacc",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "home.widgets.headerNotification.notFound"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        id: "view-all-notification",
                                                        text: "",
                                                        link: "",
                                                        color: "primary",
                                                        to: {
                                                          name: "Notifications",
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                "home.widgets.headerNotification.viewAll"
                                                              )
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "View all notifications"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: { bottom: "", rounded: "", "offset-y": true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          class: [
                                            !_vm.hasAnyAuthority(
                                              "ROLE_ADMIN"
                                            ) && _vm.authenticated
                                              ? "pl-0"
                                              : "",
                                            "navbar--menu",
                                          ],
                                          attrs: { text: "", ripple: false },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            attrs: {
                                              color: "blue",
                                              size: "48",
                                            },
                                          },
                                          [
                                            _c("v-gravatar", {
                                              staticClass:
                                                "gravatar-img position-absolute",
                                              staticStyle: { "z-index": "2" },
                                              attrs: {
                                                email: _vm.user.email,
                                                alt: _vm.user.fullName,
                                                size: 48,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-large": "",
                                                  color: "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-account-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-none d-sm-flex flex-column align-start mx-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "subtitle-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.user.fullName)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "active-entity" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.activeEntity.name)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          { staticClass: "d-none d-md-flex" },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "navbar--menu right-menu-desktop",
                                        staticStyle: { height: "auto" },
                                        attrs: {
                                          text: "",
                                          "min-width": "36",
                                          ripple: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleRightDrawer()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            attrs: {
                                              color: "blue",
                                              size: "32",
                                            },
                                          },
                                          [
                                            _c("v-gravatar", {
                                              staticClass:
                                                "gravatar-img position-absolute",
                                              staticStyle: { "z-index": "2" },
                                              attrs: {
                                                email: _vm.user.email,
                                                alt: _vm.user.fullName,
                                                size: 32,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-large": "",
                                                  color: "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-account-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-none d-sm-flex flex-column align-start mx-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "subtitle-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.user.fullName)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "active-entity" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.activeEntity.name)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          { staticClass: "d-none d-md-flex" },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3901141053
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "mx-auto",
                          attrs: { "max-width": "400", outlined: "" },
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm.userCompanies.length
                                ? _c(
                                    "v-subheader",
                                    { staticClass: "primary--text" },
                                    [_vm._v("COMPANIES")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userCompanies
                                ? _c(
                                    "v-list-item-group",
                                    {
                                      attrs: { color: "primary" },
                                      model: {
                                        value: _vm.activeCompany,
                                        callback: function ($$v) {
                                          _vm.activeCompany = $$v
                                        },
                                        expression: "activeCompany",
                                      },
                                    },
                                    _vm._l(
                                      _vm.userCompanies,
                                      function (entity, index) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: entity.company.id,
                                            on: {
                                              click: function ($event) {
                                                return _vm.setActiveEntity(
                                                  entity,
                                                  "COMPANY",
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(entity.company.name)
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userCompanies.length
                                ? _c("v-divider", { staticClass: "my-3" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userShops.length
                                ? _c(
                                    "v-subheader",
                                    { staticClass: "primary--text" },
                                    [_vm._v("SHOPS")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userShops
                                ? _c(
                                    "v-list-item-group",
                                    {
                                      attrs: {
                                        mandatory: "",
                                        color: "primary",
                                      },
                                      model: {
                                        value: _vm.activeShop,
                                        callback: function ($$v) {
                                          _vm.activeShop = $$v
                                        },
                                        expression: "activeShop",
                                      },
                                    },
                                    _vm._l(
                                      _vm.userShops,
                                      function (entity, index) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: entity.shop.id,
                                            on: {
                                              click: function ($event) {
                                                return _vm.setActiveEntity(
                                                  entity,
                                                  "SHOP",
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(entity.shop.name)
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userShops.length
                                ? _c("v-divider", { staticClass: "my-3" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-item-group",
                                { attrs: { color: "primary" } },
                                [
                                  _c(
                                    "v-list-item",
                                    { attrs: { to: "/account/settings" } },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.menu.account.settings"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.dialog = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.menu.account.logout"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "280" },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "px-7 py-8" },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "p-0 pb-3 text-h5",
                      staticStyle: { "border-bottom": "1px solid #1890ff" },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("home.widgets.signout.title"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    {
                      staticClass: "p-0 mt-4 mb-8",
                      staticStyle: {
                        "font-size": "14px",
                        "line-height": "24px",
                        color: "#141414",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("home.widgets.signout.message")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "px-0 justify-content-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: {
                            "min-width": "71",
                            color: "secondary",
                            rounded: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("home.widgets.signout.cancel"))
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-4 text-uppercase",
                          staticStyle: { "font-size": "12px" },
                          attrs: {
                            "min-width": "71",
                            color: "primary",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.logout()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("home.widgets.signout.yes")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }